
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'

    import userList from '@/store/entities/userinfo'
    import Enums from '@/lib/enums'
    import appconst from '@/lib/appconst';
    class Packed {
        inputSackNums: number = 0;
        inputBaseSkuNums: number = 0;
        warehouseReMark: string;
    }
    @Component
    export default class EditLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        selectuser: userList = new userList();
        user: Array<userList> = [];
        automaticJump: boolean;
        PackedModel: Packed = new Packed();

        created() {
            this.get();
        }
        async get() {

            this.user = await this.$store.dispatch({
                type: 'user/getUserList',
                data: {}
            });
            if (this.user.length > 0) {
                var data = this.user.filter(function (item) { return item.id == abp.session.userId });
                if (data.length > 0) {
                    this.selectuser.id = data[0].id;
                }
            }

        }

        async check() {
            var ordertype = this.$store.state.backabroadorder.ordertype;
            this.automaticJump = this.$store.state.backabroadorder.automaticJump;
            var abnormalOrderList = this.$store.state.backabroadorder.abnormalOrderList;
            if (ordertype == 0) {
                var orderNumber: string[] = [];
                for (var i = 0; i < abnormalOrderList.length; i++) {
                    if (abnormalOrderList[i].abnormalUserId != this.selectuser.id) {
                        orderNumber.push(abnormalOrderList[i].orderNumber);
                    }
                }
                var _this = this;
                if (orderNumber.length > 0) {
                    _this.$Modal.confirm({
                        title: "是否打包", content: "订单编号为【" + orderNumber + "】,标记异常业务员非现在打包业务员，是否继续标为已打包？", width: 800, onOk: () => {
                            _this.save();
                        }
                    });
                }
                else {
                    this.save();
                }
            } else {
                this.save();
            }
        }


        async save() {
            var id = this.$store.state.backabroadorder.id;
            await this.$store.dispatch({
                type: 'backabroadorder/orderBale',
                data: { id: id, SackNums: this.PackedModel.inputSackNums, BaseSkuNums: this.PackedModel.inputBaseSkuNums, packedUserId: this.selectuser.id, warehouseReMark: this.PackedModel.warehouseReMark }
            });
            var timestamp1 = (new Date()).valueOf().toString();
            if (this.automaticJump) {
                this.$router.push({ name: 'intoabroadLogistics', params: { JumpPage: timestamp1 } });
            }
            (this.$refs.packForm as any).resetFields();
            this.$emit('save-success');
            this.$emit('input', false);
        }


        cancel() {
            (this.$refs.packForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {

            if (!value) {
                this.$emit('input', value);
            } else {
                this.PackedModel.inputBaseSkuNums = this.$store.state.backabroadorder.BaseSkuNums;
            }
        }
    }
